:host {
  display: inline-block;

  /** @prop --foreground-color: Defines the foreground color. */
  --foreground-color: var(--dnn-color-foreground, #000);

  /** @prop --background-color: Defines the background color. */
  --background-color: var(--dnn-color-background, #fff);

  /** @prop --focus-color: Defines the color when the component is focused. */
  --focus-color: var(--dnn-color-primary, #3792ED);

  /** @prop --control-radius: Defines the radius for the control corners. */
  --control-radius: var(--dnn-controls-radius, 3px);
 
  /** @prop --contast-text-align: Allows customizing the text alignment of the contast indicator text. */
  --contast-text-align: left;
}
dnn-fieldset{
  width: 100%;
}

.inner-container{
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  background-color: var(--background-color);
}

button{
  margin: 0 0 0 1em;
  padding: 0;
  border: none;
  background-color: transparent;
  width: 1em;
  height: 1em;
  svg{
    fill: var(--dnn-color-primary);
    transform: scale(1.5);
  }
}

.color-preview{
  min-height: 1em;
  min-width: 10em;
  display: flex;
  width: 100%;
  position: relative;
  >div{
    flex: 1;
  }
  .contrast{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    hr {
      min-width: 1em;
      border-width: 0.1em 0 0.1em 0;
      border-style: solid;
    }
  }
}

h3{
  text-align: center;
}

.modal-content{
  margin: 0.5em;
}

.controls{
  display: flex;
  justify-content: space-between;
  margin-top: 1em;
}

dnn-fieldset{
  --fieldset-foreground-color: var(--foreground-color);
  --fieldset-background-color: var(--background-color);
  --fieldset-focus-color: var(--focus-color);
  --fieldset-danger-color: var(--danger-color);
  --fieldset-control-radius: var(--control-radius);
}